export type StatusTone =
  | 'neutral'
  | 'new'
  | 'progress'
  | 'done'
  | 'warning'
  | 'info'
  | 'danger';

interface StatusPillProps {
  readonly label: string;
  readonly tone?: StatusTone;
}

/** One status vocabulary for the whole system: same tone → same colour everywhere. */
export function StatusPill({ label, tone = 'neutral' }: StatusPillProps) {
  return <span className={`forq-status-pill forq-status-pill--${tone}`}>{label}</span>;
}
